import DashboardPage from "./DashboardPage";
import DashboardSelection from "./DashboardSelection"

export default DashboardPage;

export {
  DashboardSelection
};